import { useEffect } from "react";
import { Link } from "react-router-dom";
import manifest from "../../content/generated/route-manifest.json";
import type { ContentRouteEntry } from "../../domain/content-schema";
import { repairLegacyEncoding } from "../../platform/content/repairLegacyEncoding";
import styles from "./ClinicalCardsIndex.module.css";

const featuredPath = "/klinik-kartlar/cocukluk-caginda-akut-karin-cerrahi-aciller";
const cards = (manifest as ContentRouteEntry[]).filter((entry) => entry.category === "clinical_cards" && entry.kind === "clinical_card");

export function ClinicalCardsIndex() {
  useEffect(() => { document.title = "Klinik Kartlar | PedEmUP"; }, []);
  return (
    <div className={styles.page}>
      <header><p>30 saniyeden 20 dakikaya</p><h1>Klinik Kartlar</h1><span>Hasta başında alarm bulgularını, ilk yaklaşımı ve sık hataları aynı güvenli yapıda gözden geçirin.</span></header>
      <section aria-labelledby="cards-title">
        <div className={styles.heading}><p>{cards.length} klinik kart</p><h2 id="cards-title">Klinik ihtiyacınıza göre seçin</h2></div>
        <div className={styles.grid}>{cards.map((card) => {
          const ready = card.path === featuredPath;
          return <Link key={card.id} className={ready ? styles.ready : ""} to={card.path}><span>{ready ? "Yayında" : "Migrasyon sırasında"}</span><h3>{repairLegacyEncoding(card.title)}</h3><p>{ready ? "Alarm bulguları, ilk beş dakika, hızlı ayırıcı tanı ve güvenlik uyarıları." : "Kaynak metin doğrulandı; yapılandırılmış klinik karta aktarılacak."}</p><strong>{ready ? "Kartı aç" : "İçeriği görüntüle"} →</strong></Link>;
        })}</div>
      </section>
    </div>
  );
}
